import odata from 'odata-client';
import {
    CREATE_DRIVER_ENTRIES_REQUEST,
    CREATE_DRIVER_ENTRIES_ERROR,
    CREATE_DRIVER_ENTRIES_SUCCESS,
    TOKEN_EXPIRED
} from '../../types';
import { getServiceUrl, getDefaultHeader } from '../../../utils';
import RESOURCES from '../../../api/resources';
import { showNotification } from '../../notification';

export const tokenExpired = () => ({
    type: TOKEN_EXPIRED
});

export const createDriverEntriesRequest = () => ({
    type: CREATE_DRIVER_ENTRIES_REQUEST,
});

export const createDriverEntriesError = errorOrResults => ({
    type: CREATE_DRIVER_ENTRIES_ERROR,
    error: errorOrResults.message,
});

export const createDriverEntriesSuccess = payload => ({
    type: CREATE_DRIVER_ENTRIES_SUCCESS,
    payload,
});

export default (queryData) => async (dispatch, getState) => {
    dispatch(createDriverEntriesRequest());

    const query = odata({service: getServiceUrl()}).resource(RESOURCES.DriverEntries);

    const errorOrResult = await query.post({
        ...queryData,
        Driver: { ID: queryData.Driver.ID },
        MixingPlant: queryData.MixingPlant ? { ID: queryData.MixingPlant.ID } : null
    }, {
        headers: {
          Authorization: `Bearer ${getState().user.token}`,
          "X-IAS-SessionID": `${getState().user.changeMessageToken}`,
          ...getDefaultHeader()
        }
    })
        .then(resp => resp)
        .then(res => {
            const ok = res.statusCode <= 299 && res.statusCode >= 200;

            if (res.statusCode === 500) {
                const errorKey = "GENERAL_SERVER_ERROR";
                return new Error(errorKey);
            } else if (!ok) {
                console.log('update pensum api error', res.toJSON());
                const body = JSON.parse(res.body);
                const { Error: { Message } } = body
                const errorKey = res.statusCode === 401 ? `401: ${Message}` : `${Message}`;
                return new Error(errorKey);
            } else {
                const body = JSON.parse(res.body);
                const { "@odata.context": omit, ...payload } = body;
                const payloadObj = {
                    ID: payload.ID,
                    Driver: queryData.Driver,
                    Payload: queryData.Payload,
                    StartTime: queryData.StartTime,
                    Comment: queryData.Comment,
                    MixingPlant: queryData.MixingPlant,
                    SortOrder: payload.SortOrder
                }
                return payloadObj;
            }
        })
        .catch((error) => {
            console.error('Error:', error);
            dispatch(showNotification("Request probably timed out.", "error"))
        })

    if (errorOrResult instanceof Error) {
        dispatch(createDriverEntriesError(errorOrResult));
        if (errorOrResult.message.split(":")[0] === "401") {
            dispatch(tokenExpired());
            dispatch(showNotification(errorOrResult.message.split(":")[1], "error"))
        }
        console.log("CODE ERROR: ", errorOrResult.message);
        /*dispatch(showNotification(errorOrResult.message, "error"))*/
        return errorOrResult;
    } else {
        /*dispatch(showNotification("SUCCESSFUL_SAVE", "success"))*/
    }

    dispatch(createDriverEntriesSuccess(errorOrResult));

    return errorOrResult;
};